<div class="color-palette adc-mt50" appClickOutside (clickOutside)="closeAllPickers()">
    <div class="color-block" *ngFor="let color of colors; let i = index" [style.backgroundColor]="color.color">
        <div class="close-div">
            <span class="material-symbols-outlined" (click)="removeColor(i)">close</span>
        </div>
        <div class="edit-div" (click)="openColorPicker(i)">
            <!-- <span>Edit</span> -->
            <span class="material-symbols-outlined">edit</span>
        </div>
        <div class="color-picker-dropup" *ngIf="color.isPickerVisible">
            <input type="color" class="adc-color-picker" [(ngModel)]="colors[i].color" (change)="addColor(i, 'edit')"/>
            <!-- <button (click)="addColor(i, 'edit')">Add</button> -->
        </div>

    </div>

    <div class="color-block add-color" (click)="openColorPicker(-1)">
        <span class="adc-mb2">+</span>

        <div class="color-picker-dropup" *ngIf="isNewColorPickerVisible">
            <input type="color" class="adc-color-picker" [(ngModel)]="newColor"/>
            <button (click)="addColor(-1, 'new')">Add</button>
        </div>
    </div>
</div>